export class 期限切れ破棄破損ダイアログ種類型 {
  タイトル: string;
  複写である: boolean;
  選択期限切れ破棄破損シーケンス番号: number | null;

  constructor(タイトル: string, 複写である: boolean, 選択期限切れ破棄破損シーケンス番号: number | null) {
    this.タイトル = タイトル;
    this.複写である = 複写である;
    this.選択期限切れ破棄破損シーケンス番号 = 選択期限切れ破棄破損シーケンス番号;
  }
}
